import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { makeRowColumn, getHeadObj } from 'lib/commonLib';
import { analysisDayStatistics } from 'lib/api/adex';

import FilterWrap from 'components/atoms/FilterWrap';
import TableContainer from 'components/molecules/MbTable';
import StatisticsCommonFilter from 'components/organisms/StatisticsCommonFilter';

import AnalysisDayStatisticsGraph from './AnalysisDayStatisticsGraph';

let initialization = false;
// 공통 필터에서 초기값 받아왔는지 확인
let getInitParam = false;
const AnalysisDayStatistics = () => {
  const { t } = useTranslation();

  const initParam = {
    advrtsPrdtCode: '01',
  };

  const [params, setParams] = useState(initParam);

  useEffect(() => {
    // 렌더링 후에 실행됨
    // params setting(필터링 혹은 초기 param setting) > 렌더링 > 초기화 값 초기화
    initialization = false;
  }, [params]);

  // header 및 body 컬럼 커스텀
  const customized = {
    STATS_DTTM: {
      makeHead: (headsMap) => {
        return `${getHeadObj(headsMap, 'STATS_DTTM').label}`;
      },
      makeBody: (rowObj, headsMap) => {
        const statsDttm = getHeadObj(headsMap, 'STATS_DTTM');
        const dateValue = makeRowColumn(
          rowObj['STATS_DTTM'],
          'date',
          'YYYY-MM-DD'
        );
        var dayOfWeek = new Date(dateValue).getDay();

        let dayColor;
        if (dayOfWeek === 0) {
          dayColor = {
            color: 'red',
          };
        } else if (dayOfWeek === 6) {
          dayColor = {
            color: 'blue',
          };
        }

        return (
          <>
            <p style={dayColor}>
              {makeRowColumn(
                rowObj['STATS_DTTM'],
                statsDttm.type,
                statsDttm.format
              )}
            </p>
          </>
        );
      },
    },
    PAR_EPRS_CNT: {
      makeHead: (headsMap) => {
        return <>{t('광고요청수')}</>;
      },
      makeBody: (rowObj, headsMap) => {
        const parEprsCnt = getHeadObj(headsMap, 'PAR_EPRS_CNT');
        return (
          <>
            {makeRowColumn(
              rowObj['PAR_EPRS_CNT'],
              parEprsCnt.type,
              parEprsCnt.format
            )}
          </>
        );
      },
    },
    ENT_RATE: {
      makeHead: (headsMap) => {
        return <>{t('요청수 비율')}</>;
      },
      makeBody: (rowObj, headsMap) => {
        const entRate = getHeadObj(headsMap, 'ENT_RATE');
        return (
          <>{makeRowColumn(rowObj['ENT_RATE'], entRate.type, entRate.format)}</>
        );
      },
    },
    TOT_EPRS_CNT: {
      makeHead: (headsMap) => {
        return <>{t('광고 요청 받은수')}</>;
      },
      makeBody: (rowObj, headsMap) => {
        const totEprsCnt = getHeadObj(headsMap, 'TOT_EPRS_CNT');
        return (
          <>
            {makeRowColumn(
              rowObj['TOT_EPRS_CNT'],
              totEprsCnt.type,
              totEprsCnt.format
            )}
          </>
        );
      },
    },
    EXL_ITL_EPRS_CNT: {
      makeHead: (headsMap) => {
        return <>{t('낙찰수')}</>;
      },
      makeBody: (rowObj, headsMap) => {
        const exlItlEprsCnt = getHeadObj(headsMap, 'EXL_ITL_EPRS_CNT');
        return (
          <>
            {makeRowColumn(
              rowObj['EXL_ITL_EPRS_CNT'],
              exlItlEprsCnt.type,
              exlItlEprsCnt.format
            )}
          </>
        );
      },
    },
    EXL_ITL_EPRS_RATE: {
      makeHead: (headsMap) => {
        return <>{t('낙찰율')}</>;
      },
      makeBody: (rowObj, headsMap) => {
        const exlItlEprsRate = getHeadObj(headsMap, 'EXL_ITL_EPRS_RATE');
        return (
          <>
            {makeRowColumn(
              rowObj['EXL_ITL_EPRS_RATE'],
              exlItlEprsRate.type,
              exlItlEprsRate.format
            )}
          </>
        );
      },
    },
  };

  /**
   * 필터 초기화
   */
  const handleOnReset = () => {
    initialization = true;
    setParams(initParam);
  };

  const getParam = (newParams) => {
    getInitParam = true;
    setParams({
      ...params,
      ...newParams,
    });
  };

  return (
    <>
      <FilterWrap handleOnReset={handleOnReset}>
        <StatisticsCommonFilter
          initialization={initialization}
          getParam={getParam}
          noneExternalFilter={true}
          noneDisplayFilter={true}
        />
      </FilterWrap>
      {getInitParam && (
        <>
          <AnalysisDayStatisticsGraph params={params} />
          <TableContainer
            dataReqPromise={analysisDayStatistics}
            params={{ ...params }}
            sort="desc"
            order="STATS_DTTM"
            dense={true}
            customized={customized}
            hasExcel
          />
        </>
      )}
    </>
  );
};

export default AnalysisDayStatistics;
